module.exports = __webpack_public_path__ + "static/media/gavi.6b627836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gavi.png
// module id = 993
// module chunks = 0